export const persons = [
  {
    id: 'su-wanning',
    name: '苏晚宁',
    role: '影视演员',
    avatar:
      'https://readdy.ai/api/search-image?query=stylized%20editorial%20portrait%20illustration%20of%20an%20elegant%20young%20woman%20with%20long%20hair%2C%20warm%20coral%20and%20cream%20color%20palette%2C%20soft%20studio%20lighting%2C%20minimal%20clean%20background%2C%20artistic%20magazine%20style%2C%20high%20detail&width=320&height=320&seq=person-suwanning&orientation=squarish',
    note: '近年活跃的女演员，代表作以都市情感题材为主。',
  },
  {
    id: 'lu-zeyan',
    name: '陆则言',
    role: '流行歌手',
    avatar:
      'https://readdy.ai/api/search-image?query=stylized%20editorial%20portrait%20illustration%20of%20a%20cool%20young%20man%20with%20short%20hair%2C%20warm%20amber%20and%20cream%20color%20palette%2C%20soft%20studio%20lighting%2C%20minimal%20clean%20background%2C%20artistic%20magazine%20style%2C%20high%20detail&width=320&height=320&seq=person-luzeyan&orientation=squarish',
    note: '唱作型歌手，早年由唱片公司打造出道。',
  },
  {
    id: 'jiang-yu',
    name: '江屿',
    role: '影视导演',
    avatar:
      'https://readdy.ai/api/search-image?query=stylized%20editorial%20portrait%20illustration%20of%20a%20thoughtful%20middle-aged%20man%20with%20glasses%2C%20warm%20coral%20and%20beige%20color%20palette%2C%20soft%20studio%20lighting%2C%20minimal%20clean%20background%2C%20artistic%20magazine%20style%2C%20high%20detail&width=320&height=320&seq=person-jiangyu&orientation=squarish',
    note: '以细节控著称的导演，作品多为群像叙事。',
  },
  {
    id: 'wen-zhixia',
    name: '温知夏',
    role: '综艺主持人',
    avatar:
      'https://readdy.ai/api/search-image?query=stylized%20editorial%20portrait%20illustration%20of%20a%20bright%20young%20woman%20with%20bob%20hair%2C%20warm%20coral%20and%20pink%20cream%20palette%2C%20soft%20studio%20lighting%2C%20minimal%20clean%20background%2C%20artistic%20magazine%20style%2C%20high%20detail&width=320&height=320&seq=person-wenzhixia&orientation=squarish',
    note: '直播与综艺双栖主持人，以反应快著称。',
  },
  {
    id: 'gu-zhao',
    name: '顾昭',
    role: '影视制片人',
    avatar:
      'https://readdy.ai/api/search-image?query=stylized%20editorial%20portrait%20illustration%20of%20a%20confident%20woman%20with%20tied%20hair%2C%20warm%20amber%20and%20cream%20color%20palette%2C%20soft%20studio%20lighting%2C%20minimal%20clean%20background%2C%20artistic%20magazine%20style%2C%20high%20detail&width=320&height=320&seq=person-guzhao&orientation=squarish',
    note: '多年制片经验，负责过多部热播项目。',
  },
  {
    id: 'shen-yan',
    name: '沈砚',
    role: '编剧',
    avatar:
      'https://readdy.ai/api/search-image?query=stylized%20editorial%20portrait%20illustration%20of%20a%20quiet%20young%20man%20with%20messy%20hair%2C%20warm%20green%20and%20cream%20color%20palette%2C%20soft%20studio%20lighting%2C%20minimal%20clean%20background%2C%20artistic%20magazine%20style%2C%20high%20detail&width=320&height=320&seq=person-shenyan&orientation=squarish',
    note: '擅长现实题材的编剧，风格偏冷静克制。',
  },
  {
    id: 'bai-lu',
    name: '白露',
    role: '平面模特',
    avatar:
      'https://readdy.ai/api/search-image?query=stylized%20editorial%20portrait%20illustration%20of%20a%20fashion%20model%20woman%20with%20sleek%20hair%2C%20warm%20amber%20and%20beige%20palette%2C%20soft%20studio%20lighting%2C%20minimal%20clean%20background%2C%20artistic%20magazine%20style%2C%20high%20detail&width=320&height=320&seq=person-bailu&orientation=squarish',
    note: '常出现在品牌大片中的模特。',
  },
  {
    id: 'han-shuo',
    name: '韩朔',
    role: '男演员',
    avatar:
      'https://readdy.ai/api/search-image?query=stylized%20editorial%20portrait%20illustration%20of%20a%20serious%20young%20man%20with%20short%20black%20hair%2C%20warm%20coral%20and%20cream%20palette%2C%20soft%20studio%20lighting%2C%20minimal%20clean%20background%2C%20artistic%20magazine%20style%2C%20high%20detail&width=320&height=320&seq=person-hanshuo&orientation=squarish',
    note: '近年上升较快的男演员，多出演成长题材。',
  },
  {
    id: 'tang-ning',
    name: '唐宁',
    role: '艺人经纪',
    avatar:
      'https://readdy.ai/api/search-image?query=stylized%20editorial%20portrait%20illustration%20of%20a%20professional%20woman%20in%20a%20blazer%2C%20warm%20green%20and%20cream%20color%20palette%2C%20soft%20studio%20lighting%2C%20minimal%20clean%20background%2C%20artistic%20magazine%20style%2C%20high%20detail&width=320&height=320&seq=person-tangning&orientation=squarish',
    note: '在多家公司之间辗转的资深经纪人。',
  },
  {
    id: 'lin-zhiyao',
    name: '林知遥',
    role: '影视演员',
    avatar:
      'https://readdy.ai/api/search-image?query=stylized%20editorial%20portrait%20illustration%20of%20a%20soft%20young%20woman%20with%20curly%20hair%2C%20warm%20coral%20and%20beige%20palette%2C%20soft%20studio%20lighting%2C%20minimal%20clean%20background%2C%20artistic%20magazine%20style%2C%20high%20detail&width=320&height=320&seq=person-linzhiyao&orientation=squarish',
    note: '气质偏文艺的女演员，常参演剧集配角。',
  },
] as const;